/* eslint-disable no-nested-ternary */
import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react'
import classNames from 'classnames'
import Icon from '../../component/icon'
import './index.less'

const Input = forwardRef((props, ref) => {
  const {
    wrapClassName, placeholder = '请输入', onFocus, onBlur, withBorder, onInput, onChange, disabled,
    prefix, suffix, wrapStyle, scalable = false, onScale, allowClear, onClear, value, ...otherProps
  } = props
  const $input = useRef()
  const $inputWrap = useRef()
  const [isFocus, setFocus] = useState(false)
  const [_value, setValue] = useState(value)

  useEffect(() => {
    if (value !== _value) {
      setValue(value)
    }
  }, [value])

  const focus = (e) => {
    setFocus(true)
    onScale?.(true)
    onFocus?.(e)
  }
  const blur = (e) => {
    setFocus(false)
    !_value && onScale?.(false)
    onBlur && onBlur(e)
  }
  const clear = (e) => {
    onClear?.(e)
    onScale?.(false)
  }
  const _onInput = (e) => {
    setValue(e.target.value)
    onInput?.(e)
    onChange?.(e)
  }
  useImperativeHandle(ref, () => ({
    $input: $input.current,
    $inputWrap: $inputWrap.current
  }))

  return <span
    onClick={(e) => e.stopPropagation()}
    className={classNames('meinian-input', wrapClassName, { focus: isFocus, scalable: _value ? false : isFocus ? false : scalable, bordered: withBorder })}
    style={wrapStyle}
    onMouseEnter={() => { setFocus(true); onScale?.(true) }}
    onMouseLeave={() => { setFocus(false); !_value && onScale?.(false) }}
    ref={$inputWrap}
  >
    {prefix ? <span className="prefix" onMouseDown={(e) => { e && e.preventDefault() }}>{prefix}</span> : null}
    <input
      disabled={disabled}
      ref={$input}
      {...otherProps}
      value={_value}
      onInput={_onInput}
      onFocus={focus}
      onBlur={blur}
      placeholder={!isFocus || !scalable ? placeholder : null}
    />
    {!isFocus && scalable && !_value ? <Icon type="m-sousuo" className="placeholder-icon" /> : null}
    {allowClear && _value ? <Icon type="m-guanbi" onClick={clear} className="clear-icon" /> : null}
    {suffix ? <span className="suffix">{suffix}</span> : null}
  </span>
})

Input.Search = (props) => {
  const { onChange, prefix, wrapClassName, ...otherProps } = props
  const $search = useRef()
  let searchTimeOut = null
  const onInput = () => {
    clearTimeout(searchTimeOut)
    searchTimeOut = setTimeout(() => {
      onChange?.($search.current.$input.value)
    }, 600)
  }
  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      $search.current.$input.blur()
    }
  }
  return <Input
    wrapClassName={classNames('meinian-search', wrapClassName)}
    {...otherProps}
    onChange={onInput}
    onKeyUp={onKeyUp}
    ref={$search}
    prefix={prefix || <Icon type="m-sousuo" className="icon" />}
  />
}

export const NewSearch = (props) => {
  const { onChange, prefix, wrapClassName, ...otherProps } = props
  const $search = useRef()
  let searchTimeOut = null

  const onInput = (e) => {
    clearTimeout(searchTimeOut)
    searchTimeOut = setTimeout(() => {
      onChange?.(e.target.value)
    }, 600)
  }

  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      $search.current.$input.blur()
    }
  }
  return <Input
    wrapClassName={classNames('meinian-new-search', wrapClassName)}
    onChange={onInput}
    onKeyUp={onKeyUp}
    ref={$search}
    allowClear
    style={{ marginLeft: '6px' }}
    prefix={prefix || <Icon type="m-sousuo" className="icon" />}
    {...otherProps}
  />
}

export default Input
